var MethodMaterialMode = /** @class */ (function () {
    function MethodMaterialMode() {
    }
    /**
     *
     */
    MethodMaterialMode.SINGLE_PASS = 'singlePass';
    /**
     *
     */
    MethodMaterialMode.MULTI_PASS = 'multiPass';
    return MethodMaterialMode;
}());
export { MethodMaterialMode };
